.position-tracker {
  position: fixed;
  width: 2px;
  height: 2px;
  margin-top: -1px;
  margin-left: -1px;
  pointer-events: none;
}
